import React from "react"
import Header from "../components/header.js"
import "../components/flex-grid.scss"
import "../components/global.scss"
import "../components/locomotive.css"


export default function Layout({ children }) {
    return (
        <div className="layout">
            <Header />
            {children}
        </div>
    )
}